import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import global from '../../../common/utility/global';
import Header from '../../../components/Header';
import { message } from 'antd';
import moment from 'moment';
import Filters from './Filters';
import GeneralTable from './GeneralTable';
import ResumenTable from './ResumenTable';

import establecimientoService from '../../../service/administracion/establecimientoService';
import productoService from '../../../service/administracion/productoService';
import almacenService from '../../../service/administracion/almacenService';
import reporteRotacionService from '../../../service/logistica/reporteRotacionService';
export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        // this.props.onSetBreadcrumb();
        this.state = {
            establecimientos: [],
            almacenes: [],
            monedas: [],
            productos: [],
            estados: [{ id: 1, nombre: 'Mayor Rotación' }, { id: 2, nombre: 'Mejor Rotación' }],
            productosAutocomplete: [],
            almacenesLoading: false,
            productosLoading: false,
            loadingExcel: false,
            establecimientosLoading: false,
            monedasLoading: false,
            showGeneral: true,
            showResumen: false,
            showDetallado: false,
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                lote: "",
                idEstablecimiento: 0,
                idAlmacen: 0,
                idProducto: 0,
                tipoReporte: 1,
                incluirNotaVenta: true,
                referencia: '',
                estado: 0,

            },
            DataSource: [],
            pagination: PAGINATION,
        }
    }


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter };
        }
    };

    handleChange = async (property, value) => {

     const MAX_MESES = 18;
        // Clonamos el filtro con el nuevo valor
        const filter = { ...this.state.filter, [property]: value };

        const { fechaInicioStr, fechaFinStr } = filter;

        // Solo validamos si ambas fechas existen
        if (fechaInicioStr && fechaFinStr) {
            const inicio = moment(fechaInicioStr, 'DD/MM/YYYY');
            const fin = moment(fechaFinStr, 'DD/MM/YYYY');

            const meses = fin.diff(inicio, 'months', true);

            if (meses > MAX_MESES) {
                message.error('El rango máximo permitido es de 18 meses');
                return; // ⛔ no actualiza el estado
            }
        }

        this.setState({ filter: filter });

        if (property === "idEstablecimiento") {
            this.setState({ almacenesLoading: true });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                filter: { ...this.state.filter, idAlmacen: 0 },
                almacenes: almacenes ? almacenes : [],
                almacenesLoading: false
            });
        }
    };


    handleSearchAutocomplete = (value) => {
        try {
            const result = this.state.productos.filter(item => {
                return (item.nombre).toUpperCase().match(value.toUpperCase());
            }).slice(0, 75);
            this.setState({ productosAutocomplete: result });
        } catch (error) {
            console.log(error);
        }
    };

    handleChangeAutocomplete = (value) => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: value.key
            }
        });
    };

    handleClearAutocomplete = () => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: 0
            }
        });
    }

    handleClearFilters = () => {
        var filter = {
            idEstablecimiento: 0,
            idAlmacen: 0,
            idProducto: 0,
            tipoReporte: 1,
            estado: 0,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            lote: "",
            incluirNotaVenta: true,
            referencia: ''
        };
        this.setState({
            filter,
            DataSource: []
        });
    };

    handleSearch = async () => {

        var dataSource = [];
        if (this.state.filter.tipoReporte === 1) {
            dataSource = await reporteRotacionService.general(this.state.filter);
            this.setState({
                pagination: dataSource ? dataSource : [],
                showGeneral: true,
                showResumen: false,
                showDetallado: false
            });
        } else if (this.state.filter.tipoReporte === 2) {
            dataSource = await reporteRotacionService.resumen(this.state.filter);
            this.setState({
                pagination: dataSource ? dataSource : [],
                showGeneral: false,
                showResumen: true,
                showDetallado: false
            });
        }
    }

    handleExportExcelGeneral = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteRotacionService.excelGeneral(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte Stock General.xlsx");
    }

    handleExportExcelResumen = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteRotacionService.excelResumen(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte Stock General - Resumén.xlsx");
    }


    handleSearchKardexEstablecimiento = async () => {
        const dataSource = await reporteRotacionService.DetalladoEstablecimientoTable(this.state.filter);
        this.setState({
            DataSource: dataSource ? dataSource : []
        });
    }


    handleExportExcelDetallado = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteRotacionService.excelDetallado(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Kardex Detallado.xlsx");
    }

    handleExportExcelResumido = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteRotacionService.excelResumido(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Kardex Resumido.xlsx");
    }

    handleChangeResumen = async (pagination) => {

        var dataSource = [];
        const filter = { ...this.state.filter, ...pagination };
        this.setState({ filter });
        dataSource = await reporteRotacionService.resumen(filter);
        this.setState({
            pagination: dataSource ? dataSource : [],
            showGeneral: false,
            showResumen: true,
            showDetallado: false
        });
    };

    _handleChangePagination = async (pagination) => {
        var dataSource = [];
        const filter = { ...this.state.filter, ...pagination };
        this.setState({ filter });
        dataSource = await reporteRotacionService.general(filter);
        this.setState({
            pagination: dataSource ? dataSource : [],
            showGeneral: true,
            showResumen: false,
            showDetallado: false
        });
    };
    async componentDidMount() {
        this.setState({
            establecimientosLoading: true
        });
        const establecimientos = await establecimientoService.principales();
        const productos = await productoService.listar();
        const productos_filter = productos.filter(m => m.idTipoProducto === 1);
        const dataSource = await reporteRotacionService.general(this.state.filter);

        this.setState({
            establecimientos: establecimientos ? establecimientos : [],
            productos: productos_filter ? productos_filter : [],
            establecimientosLoading: false,
            DataSource: dataSource.data,
            pagination: dataSource
        });
    }

    render() {

        return (
            <div>
                <Header
                    title="Reporte de Mayor Rotación"
                    onSearch={this.handleSearch}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.establecimientos}
                    almacenes={this.state.almacenes}
                    monedas={this.state.monedas}
                    productos={this.state.productosAutocomplete}
                    estados={this.state.estados}
                    establecimientosLoading={this.state.establecimientosLoading}
                    productosLoading={this.state.productosLoading}
                    almacenesLoading={this.state.almacenesLoading}
                    onSearchAutocomplete={this.handleSearchAutocomplete}
                    onChangeAutocomplete={this.handleChangeAutocomplete}
                    onClearAutocomplete={this.handleClearAutocomplete}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />

                {
                    this.state.showGeneral ?
                        <GeneralTable
                            dataSource={this.state.DataSource}
                            pagination={this.state.pagination}
                            loadingExcel={this.state.loadingExcel}
                            onExportExcel={this.handleExportExcelGeneral}
                            onChange={this._handleChangePagination}

                        />
                        :
                        <ResumenTable
                            dataSource={this.state.DataSource}
                            pagination={this.state.pagination}
                            loadingExcel={this.state.loadingExcel}
                            onExportExcel={this.handleExportExcelResumen}
                            onChange={this.handleChangeResumen}
                        />
                }
            </div>
        );
    }
}